/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SET_POLICY_FORM_DATA = 'SET_POLICY_FORM_DATA';
export const SET_POLICY_ENTITIES_FILTERED_ITEMS = 'SET_POLICY_ENTITIES_FILTERED_ITEMS';
export const SET_POLICY_HIERARCHY_EXPANDED_ITEMS = 'SET_POLICY_HIERARCHY_EXPANDED_ITEMS';
export const SET_POLICY_HIERARCHY_ITEMS = 'SET_POLICY_HIERARCHY_ITEMS';
export const SET_HIERARCHY_SELECTED_KEYS = 'SET_HIERARCHY_SELECTED_KEYS';
export const SET_SELECTED_HIERARCHY = 'SET_SELECTED_HIERARCHY';
export const SET_POLICY_VALIDATION_ERROR = 'SET_POLICY_VALIDATION_ERROR';
export const RESET_HIERARCHY_VALUES = 'RESET_HIERARCHY_VALUES';
export const RESET_POLICY_FORM_VALUES = 'RESET_POLICY_FORM_VALUES';
export const SET_POLICY_MODULE_DEFAULT_VALUE = 'SET_POLICY_MODULE_DEFAULT_VALUE';
export const SET_EDIT_POLICY_FORM_DATA = 'SET_EDIT_POLICY_FORM_DATA';
